import Cookies from 'js-cookie';

/**
 * Utility function to check if a specific cookie is present
 * @param cookieName - The name of the cookie to check
 * @returns boolean - Returns true if the cookie exists, otherwise false
 */
export const isCookiePresent = (cookieName: string): boolean => {
  const cookieValue = Cookies.get(cookieName); // Using js-cookie to get cookie
  return !!cookieValue; // Returns true if the cookie is found, false if not
};

/**
 * Utility function to get data from a cookie by name
 * @param cookieName - The name of the cookie to get
 * @returns any - The value of the cookie, or null if the cookie is not present
 */
export const getCookieData = (cookieName: string): any => {
  const cookieValue = Cookies.get(cookieName); // Using js-cookie to get cookie
  return cookieValue ? JSON.parse(cookieValue) : null;
};

/**
 * Utility function to set data in a cookie
 * @param cookieName - The name of the cookie to set
 * @param data - The data to store in the cookie
 * @param options - Additional cookie options like path, expires, etc.
 */
export const setCookieData = (
  cookieName: string,
  data: any,
  options?: Record<string, any>
): void => {
  Cookies.set(cookieName, JSON.stringify(data), options); // Using js-cookie to set cookie
};